import React from 'react';
import { Check, Checks, Clock, WarningCircle } from '@phosphor-icons/react';

const ReadReceipts = ({ message, isSender }) => {
  // Only show for sender's messages
  if (!isSender) return null;

  // Point 1/3 — local-first send: a message can be `pending` (queued
  // locally, not yet confirmed by the server) or `send_failed` (server
  // rejected it / retries exhausted). These take priority over the
  // delivered/read ticks below.
  if (message.send_failed) {
    return (
      <span className="inline-flex items-center ml-1" title="Failed to send — will retry">
        <WarningCircle size={15} weight="bold" className="text-red-400" />
      </span>
    );
  }
  if (message.pending) {
    return (
      <span className="inline-flex items-center ml-1" title="Sending…">
        <Clock size={14} weight="regular" className="text-gray-400" />
      </span>
    );
  }

  // Handle old messages without delivered/read fields (backward compatibility)
  // If fields are missing, assume delivered but not read
  const delivered = message.delivered !== undefined ? message.delivered : true;
  const read = message.read !== undefined ? message.read : false;

  return (
    <span className="inline-flex items-center ml-1">
      {!delivered && (
        // Single tick - Sent (not yet delivered)
        <Check size={16} weight="bold" className="text-gray-400" />
      )}

      {delivered && !read && (
        // Double tick - Delivered (not yet read)
        <Checks size={16} weight="bold" className="text-gray-400" />
      )}

      {delivered && read && (
        // Double tick Blue - Read
        <Checks size={16} weight="bold" className="text-blue-500" />
      )}
    </span>
  );
};

export default ReadReceipts;
